import { TaskStatus } from "pages/vdo-ticket/services/TaskStatus";

export const isComplete = (status) => {
    return status === TaskStatus.COMPLETE;
}

export const isFailed = (status) => {
    return status === TaskStatus.FAILED;
}